import { UtilsService } from '@abp/utils/utils.service';
import { CompilerOptions, NgModuleRef, Type } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { AppConsts } from '@shared/AppConsts';
import { SubdomainTenancyNameFinder } from '@shared/helpers/SubdomainTenancyNameFinder';
import * as moment from 'moment';
import { LocalizedResourcesHelper } from './shared/helpers/LocalizedResourcesHelper';
import { UrlHelper } from './shared/helpers/UrlHelper';
import { environment } from './environments/environment';

export class AppPreBootstrap {

    static run(appRootUrl: string, callback: () => void, resolve: any, reject: any): void {
        console.log(abp.auth.getToken());
        AppPreBootstrap.getApplicationConfig(appRootUrl, () => {
            if (UrlHelper.isInstallUrl(location.href)) {
                LocalizedResourcesHelper.loadLocalizedStylesForTheme("default", false);
                callback();
                return;
            }

            const queryStringObj = UrlHelper.getQueryParameters();
            if (queryStringObj && queryStringObj.accessToken) {
                AppPreBootstrap.setNewTokenLocalStorage(queryStringObj.newAccessToken);
                abp.auth.setToken(queryStringObj.accessToken);
                const encryptedParam = queryStringObj.encryptedAccessToken || queryStringObj.enc_auth_token;
                if (encryptedParam) {
                    const encryptedRaw = decodeURIComponent(encryptedParam);
                    AppPreBootstrap.setEncryptedTokenLocalstorage(encryptedRaw);
                }

                const returnUrl = queryStringObj.returnUrl;
                if (returnUrl) {
                    AppPreBootstrap.getUserConfiguration(() => {
                        location.href = decodeURIComponent(returnUrl);
                    });
                    return;
                }

                AppPreBootstrap.getUserConfiguration(callback);
                return;
            }

            if (queryStringObj.redirect && queryStringObj.redirect === 'TenantRegistration') {
                if (queryStringObj.forceNewRegistration) {
                    new AppAuthService().logout();
                }

                location.href = AppConsts.appBaseUrl + '/account/select-edition';
            } else if (queryStringObj.impersonationToken) {
                AppPreBootstrap.impersonatedAuthenticate(queryStringObj.impersonationToken, queryStringObj.tenantId, () => { AppPreBootstrap.getUserConfiguration(callback); });
            } else if (queryStringObj.switchAccountToken) {
                AppPreBootstrap.linkedAccountAuthenticate(queryStringObj.switchAccountToken, queryStringObj.tenantId, () => { AppPreBootstrap.getUserConfiguration(callback); });
            } else {
                let oldToken = abp.utils.getCookieValue(abp.auth.tokenCookieName);
                if (oldToken) {
                    AppPreBootstrap.getUserConfiguration(callback);
                    return
                }
                abp
                    .ajax({
                        url: `${environment.authAPIUrl}v1/account/refreshtokenmobile`,
                        method: "POST",
                        data: JSON.stringify({
                            loginVia: "PHONENUMBER",
                            AppFrom: 1,
                        }),
                        xhrFields: {
                            withCredentials: true,
                        },
                        crossDomain: true,
                    })
                    .done((result) => {

                        abp.auth.setToken(result.accessTokenOld);
                        AppPreBootstrap.setEncryptedTokenLocalstorage(
                            result.encryptedAccessToken
                        );
                        AppPreBootstrap.setNewTokenLocalStorage(result.accessToken);
                        const expiresDate = new Date(
                            Date.now() + (Number(result.expiresIn) || 0) * 1000
                        );
                        const cookieName = "token_expires_in";
                        const cookieValue = expiresDate.toString();
                        const expiryDate = new Date(expiresDate);

                        abp.utils.setCookieValue(cookieName, cookieValue, expiryDate, "/");

                        AppPreBootstrap.getUserConfiguration(callback);
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        const currentUrl = encodeURIComponent(environment.homepageUrl);
                        const loginUrl = `${environment.authUrl}auth/login?returnUrl=${currentUrl}`;
                        location.href = loginUrl;
                    })
                // .always(() => {
                //   console.log("?? Ho�n t?t (d� th�nh c�ng hay l?i).");
                // });
            }
        });
    }

    static bootstrap<TM>(moduleType: Type<TM>, compilerOptions?: CompilerOptions | CompilerOptions[]): Promise<NgModuleRef<TM>> {
        return platformBrowserDynamic().bootstrapModule(moduleType, compilerOptions);
    }

    private static getApplicationConfig(appRootUrl: string, callback: () => void) {

        return abp.ajax({
            url: appRootUrl + 'config/' + environment.appConfig,
            method: 'GET',
            headers: {
                'Abp.TenantId': abp.multiTenancy.getTenantIdCookie()
            }
        }).done(result => {

            const subdomainTenancyNameFinder = new SubdomainTenancyNameFinder();
            const tenancyName = subdomainTenancyNameFinder.getCurrentTenancyNameOrNull(result.appBaseUrl);

            AppConsts.appBaseUrlFormat = result.appBaseUrl;
            AppConsts.remoteServiceBaseUrlFormat = result.remoteServiceBaseUrl;
            AppConsts.localeMappings = result.localeMappings;

            if (tenancyName == null) {
                AppConsts.appBaseUrl = result.appBaseUrl.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.remoteServiceBaseUrl = result.remoteServiceBaseUrl.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                //CE-1395
                AppConsts.remoteServiceBaseUrlNew = result.remoteServiceBaseUrlNew.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.apiGatewayPartnerPrefix = result.apiGatewayPartnerPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.hrmPrefix = result.hrmPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.requestPrefix = result.requestPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.apiGatewayCampaignPrefix = result.apiGatewayCampaignPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                //CE-1679
                AppConsts.warehousePrefix = result.warehousePrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.partnerUrlFile = result.partnerUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.warehouseUrlFile = result.warehouseUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.campaignUrlFile = result.campaignUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.MDPrefix = result.MDPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.MDUrlFile = result.MDUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');

            } else {
                AppConsts.appBaseUrl = result.appBaseUrl.replace(AppConsts.tenancyNamePlaceHolderInUrl, tenancyName);
                AppConsts.remoteServiceBaseUrl = result.remoteServiceBaseUrl.replace(AppConsts.tenancyNamePlaceHolderInUrl, tenancyName);
                //CE-1395
                AppConsts.remoteServiceBaseUrlNew = result.remoteServiceBaseUrlNew.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.apiGatewayPartnerPrefix = result.apiGatewayPartnerPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.hrmPrefix = result.hrmPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.requestPrefix = result.requestPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.apiGatewayCampaignPrefix = result.apiGatewayCampaignPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                //CE-1679
                AppConsts.warehousePrefix = result.warehousePrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.partnerUrlFile = result.partnerUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.warehouseUrlFile = result.warehouseUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.campaignUrlFile = result.campaignUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.MDPrefix = result.MDPrefix.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
                AppConsts.MDUrlFile = result.MDUrlFile.replace(AppConsts.tenancyNamePlaceHolderInUrl + '.', '');
            }

            callback();
        });
    }

    private static getCurrentClockProvider(currentProviderName: string): abp.timing.IClockProvider {
        if (currentProviderName === 'unspecifiedClockProvider') {
            return abp.timing.unspecifiedClockProvider;
        }

        if (currentProviderName === 'utcClockProvider') {
            return abp.timing.utcClockProvider;
        }

        return abp.timing.localClockProvider;
    }

    private static impersonatedAuthenticate(impersonationToken: string, tenantId: number, callback: () => void): JQueryPromise<any> {
        abp.multiTenancy.setTenantIdCookie(tenantId);
        const cookieLangValue = "vi";// abp.utils.getCookieValue('Abp.Localization.CultureName');
        return abp.ajax({
            url: AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/ImpersonatedAuthenticate?impersonationToken=' + impersonationToken,
            method: 'POST',
            headers: {
                '.AspNetCore.Culture': ('c=' + cookieLangValue + '|uic=' + cookieLangValue),
                'Abp.TenantId': abp.multiTenancy.getTenantIdCookie()
            }
        }).done(result => {
            abp.auth.setToken(result.accessToken);
            AppPreBootstrap.setEncryptedTokenLocalstorage(result.encryptedAccessToken);
            location.search = '';
            callback();
        });
    }

    private static linkedAccountAuthenticate(switchAccountToken: string, tenantId: number, callback: () => void): JQueryPromise<any> {
        abp.multiTenancy.setTenantIdCookie(tenantId);
        const cookieLangValue = "vi";//abp.utils.getCookieValue('Abp.Localization.CultureName');
        return abp.ajax({
            url: AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/LinkedAccountAuthenticate?switchAccountToken=' + switchAccountToken,
            method: 'POST',
            headers: {
                '.AspNetCore.Culture': ('c=' + cookieLangValue + '|uic=' + cookieLangValue),
                'Abp.TenantId': abp.multiTenancy.getTenantIdCookie()
            }
        }).done(result => {
            abp.auth.setToken(result.accessToken);
            AppPreBootstrap.setEncryptedTokenLocalstorage(result.encryptedAccessToken);
            location.search = '';
            callback();
        });
    }

    private static getUserConfiguration(callback: () => void): JQueryPromise<any> {
        const cookieLangValue = "vi";//abp.utils.getCookieValue('Abp.Localization.CultureName');
        const token = abp.auth.getToken();

        let requestHeaders = {
            '.AspNetCore.Culture': ('c=' + cookieLangValue + '|uic=' + cookieLangValue),
            'Abp.TenantId': abp.multiTenancy.getTenantIdCookie()
        };

        if (token) {
            requestHeaders['Authorization'] = 'Bearer ' + token;
        }

        return abp.ajax({
            url: AppConsts.remoteServiceBaseUrl + '/AbpUserConfiguration/GetAll',
            method: 'GET',
            headers: requestHeaders
        }).done(result => {
            $.extend(true, abp, result);
            abp.clock.provider = this.getCurrentClockProvider(result.clock.provider);

            moment.locale(abp.localization.currentLanguage.name);
            (window as any).moment.locale(abp.localization.currentLanguage.name);

            if (abp.clock.provider.supportsMultipleTimezone) {
                moment.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId);
                (window as any).moment.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId);
            }

            abp.event.trigger('abp.dynamicScriptsInitialized');

            AppConsts.recaptchaSiteKey = abp.setting.get('Recaptcha.SiteKey');
            AppConsts.subscriptionExpireNootifyDayCount = parseInt(abp.setting.get('App.TenantManagement.SubscriptionExpireNotifyDayCount'));

            LocalizedResourcesHelper.loadResources(callback);
        });
    }

    public static setEncryptedTokenCookie(encryptedToken: string) {
        new UtilsService().setCookieValue(AppConsts.authorization.encrptedAuthTokenName,
            encryptedToken,
            new Date(new Date().getTime() + 365 * 86400000), //1 year
            abp.appPath
        );
    }
    public static setEncryptedTokenLocalstorage(encryptedToken: string) {
        localStorage.setItem(AppConsts.authorization.encrptedAuthTokenName, encryptedToken);
    }

    public static setNewTokenCookie(token: string) {
        new UtilsService().setCookieValue(AppConsts.authorization.newAccessToken,
            token,
            new Date(new Date().getTime() + 365 * 86400000), //1 year
            abp.appPath
        );
    }
    public static setNewTokenLocalStorage(token: string) {
        localStorage.setItem(AppConsts.authorization.newAccessToken, token);
    }
    public static getTokenCookie(key: string): string {
        return new UtilsService().getCookieValue(key);
    }
    public static getTokenLocalstorage(key: string): string {
        return localStorage.getItem(key) || '';
    }

    public static clearTokenCookies() {
        const utilsService = new UtilsService();
        utilsService.deleteCookie(AppConsts.authorization.encrptedAuthTokenName, abp.appPath);
        utilsService.deleteCookie(AppConsts.authorization.newAccessToken, abp.appPath);
        localStorage.removeItem(AppConsts.authorization.newAccessToken);
        localStorage.removeItem(AppConsts.authorization.encrptedAuthTokenName);
    }
}